/* jshint esversion: 6 */
/* jshint ignore:start */
import openbox from "../Images/open-box.png";
import returnimg from "../Images/return.png";
import time from "../Images/time-24.png";
import mastercard from "../Images/master-card.png";
import logog from '../Images/logowithname.png';
import facebook from '../Images/facebook.png';
import instagram from '../Images/instagram.png';
import twitter from '../Images/twitter.png';
import youtube from '../Images/youtube.png';
import symbol from '../Images/symbol.png';
import visa from '../Images/visa.png';
import paypal from '../Images/paypal.png';
import amex from '../Images/amex.png';
import card from '../Images/card.png';
import { Link, useNavigate } from "react-router-dom";
import { useEffect, useContext, useState } from "react";
import { MyContext } from "../Context/MyProvider";
import axios from "axios";
import { useTranslation } from "react-i18next";
import Whatapps from "../Images/whatsapp-icon.png";
import istart from "../Images/istart.png";
import iso from "../Images/iso1.png";
import dnb from "../Images/dandb.png";
import logoWithName from "../Images/logowithname.png";
import { FiBell, FiHeadphones, FiLogOut, FiPlus, FiRefreshCcw, FiSearch, FiShield, FiStar } from "react-icons/fi";

const Footer = () => {

    const { t } = useTranslation();

    const { BaseUrl, setIsLoginShow } = useContext(MyContext);
    const [pageList, setPageList] = useState([]);
    const [eventPageList, setEventPageList] = useState([]);

    const Navigate = useNavigate();

    useEffect(() => {
        axios.post(`${BaseUrl}/user_api/u_pagelist.php`)
            .then((res) => {
                setPageList(res.data.pagelist);
            })
            .catch((error) => {
                console.error("u_pagelist", error);
            });
    }, []);

    useEffect(() => {
        axios.get(`https://shop.nabhiverse.com/api/v1/dynamic-pages`)
            .then((res) => {
                setEventPageList(res?.data?.data);
            })
            .catch((error) => {
                console.error("u_pagelist", error);
            });
    }, []);

    const HandleNavigate = (path) => {
        Navigate(path);
    };

    return (
        <footer className="relative bg-gray-950 px-6 pt-10 sm:pt-12 pb-[100px] sm:pb-20">
            {/* subtle glow divider along the top edge */}
            <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-teal-500/50 to-transparent" />

            <div className="w-full">
                {/* ===== row 1: logo left, event links right ===== */}
                <div className="flex flex-col items-center gap-6 sm:flex-row sm:items-center sm:justify-between">
                    <Link to="/" aria-label="Go to home" className="shrink-0">
                        <img
                            src={logoWithName}
                            alt="Nabhiverse"
                            className="h-14 w-auto sm:h-20"
                        />
                    </Link>

                    <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 sm:justify-end">
                        {eventPageList?.map((item, i) => (
                            <Link
                                key={item?.slug ?? i}
                                to={`/event-page-dynamic/${item?.slug}`}
                                className="whitespace-nowrap text-sm text-gray-400 transition-colors hover:text-white"
                            >
                                {item?.title}
                            </Link>
                        ))}
                    </div>
                </div>

                {/* divider */}
                <div className="my-8 h-px w-full bg-gray-800" />

                {/* ===== row 2: trust badges left, copyright right ===== */}
                <div className="flex flex-col items-center gap-5 sm:flex-row sm:items-center sm:justify-between">
                    <div className="flex flex-wrap items-center justify-center gap-x-8 gap-y-3 text-sm text-gray-300 sm:justify-start">
                        <span className="flex items-center gap-2 whitespace-nowrap">
                            <FiShield className="h-4 w-4 shrink-0 text-teal-400" />
                            Fast &amp; Secure Payments
                        </span>
                        <span className="flex items-center gap-2 whitespace-nowrap">
                            <FiRefreshCcw className="h-4 w-4 shrink-0 text-teal-400" />
                            Easy Returns
                        </span>
                        <span className="flex items-center gap-2 whitespace-nowrap">
                            <FiHeadphones className="h-4 w-4 shrink-0 text-teal-400" />
                            24x7 Support
                        </span>
                    </div>

                    <p className="text-center text-xs text-gray-500 sm:text-right">
                        © 2026 Nabhiverse. All Rights Reserved.
                    </p>
                </div>
            </div>
        </footer>
    )
}

export default Footer
/* jshint ignore:end */